import { getCategoryName } from '@/helpers'
import { isMobile } from 'react-device-detect'
import { CRITEO_ACCOUNT_ID} from '@/services/Configuration'
import { error } from './Log'

const MarketingChannels = {
  onSkuChange(name, category, variantId, price) {
    setTimeout(() => {
      try {
        const categoryName = getCategoryName(category)

        //google ads
        gtag('event', 'view_item', {
          'value': price,
          'items': [{
            'id': variantId,
            'google_business_vertical': 'retail'
          }]
        })

        // Criteo
        window.criteo_q = window.criteo_q || [];
        const deviceType = isMobile ? "m" : "d";
        window.criteo_q.push(
          { event: 'setAccount', account: CRITEO_ACCOUNT_ID },
          { event: 'setEmail', email: '' },
          { event: 'setSiteType', type: deviceType },
          { event: 'viewItem', item: variantId }
        );

        //Pinterest
        if(typeof pintrk !== 'undefined')
          pintrk('track', 'pagevisit', {
            "line_items": [{
              "product_id": variantId,
              "product_category": categoryName
            }]
          })
      } catch (err) {
        error(`MarketingChannels error: ${err}`)
      }
    }, 500)
  }
}

export default MarketingChannels
